import { render, staticRenderFns } from "./fbaModal.vue?vue&type=template&id=5d3d8c78&scoped=true"
import script from "./fbaModal.vue?vue&type=script&lang=js"
export * from "./fbaModal.vue?vue&type=script&lang=js"
import style0 from "./fbaModal.vue?vue&type=style&index=0&id=5d3d8c78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3d8c78",
  null
  
)

export default component.exports